import { render, staticRenderFns } from "./PeoClients.vue?vue&type=template&id=7b623e1f&scoped=true&"
import script from "./PeoClients.vue?vue&type=script&lang=js&"
export * from "./PeoClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b623e1f",
  null
  
)

export default component.exports